export default __webpack_public_path__ + "static/media/close-green.9736e9ad.svg";